import { useEffect } from "react";

/**
 * Sets <body data-surface> to switch between the dark field viewfinder and the light console
 * paper surface. Each screen calls this on mount.
 */
export function useSurface(surface: "field" | "console") {
  useEffect(() => {
    document.body.setAttribute("data-surface", surface);
  }, [surface]);
}
